module.exports = __webpack_public_path__ + "static/media/81BNgBLT1vL._SL1500_.5af8773c.jpg";